// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3sVUOC","copy":"_3Qj8UR","link":"_1G9deL"};